import { render, staticRenderFns } from "./StyledContent.vue?vue&type=template&id=22164ab7&"
import script from "./StyledContent.vue?vue&type=script&lang=js&"
export * from "./StyledContent.vue?vue&type=script&lang=js&"
import style0 from "./StyledContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports